/**
* Related Services JS
* -----------------------------------------------------------------------------
*
* All the JS for the Related Services component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'related-services',
    selector: function() {
      return '.' + this.className;
    },

    // Hover functionality logic
    initHoverEffects: function() {
      const serviceItems = document.querySelectorAll( '.related-services__service-item' );

      serviceItems.forEach( function( item ) {
        const title = item.querySelector( '.related-services__title' );
        const description = item.querySelector( '.related-services__description' );

        // Define hover and leave handlers within the scope of the loop
        const hoverHandler = function() {
          if ( window.innerWidth >= 1024 ) {
            const descriptionHeight = description.scrollHeight;
            title.style.transform = `translateY(-${descriptionHeight}px)`;
          }
        };

        const leaveHandler = function() {
          if ( window.innerWidth >= 1024 ) {
            title.style.transform = 'translateY(0)';
          }
        };

        // Clear previous event listeners before adding new ones
        item.removeEventListener( 'mouseenter', hoverHandler );
        item.removeEventListener( 'mouseleave', leaveHandler );

        if ( title && description ) {
          item.addEventListener( 'mouseenter', hoverHandler );
          item.addEventListener( 'mouseleave', leaveHandler );
        }
      } );
    },

    // Function to handle window resize
    handleResize: function() {
      window.addEventListener( 'resize', () => {
        this.initHoverEffects(); // Reapply hover effects when window is resized
      } );
    },

    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      this.initHoverEffects(); // Initialize hover effects on load
      this.handleResize(); // Add resize event listener
    },

    finalize: function() {},
  };

  app.registerComponent( 'related-services', COMPONENT );
} )( app );
